module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-right-dashboard.b9fc6e37.png";